﻿class baseformulaeditor extends Tango.Component {
	static ti_Icon = '<svg class="svgicon-askue_ti"><use xlink:href="/data/icons/svg#icon-askue_ti"></use></svg>';
	static cti_Icon = '<svg class="svgicon-askue_contr_ti"><use xlink:href="/data/icons/svg#icon-askue_contr_ti"></use></svg>';
	static function_Icon = '<svg class="svgicon-function"><use xlink:href="/data/icons/svg#icon-function"></use></svg>';

	setSelectedRows(td) {

		var tr = td.parentElement;

		if (tr.getAttribute("selectinserted") == null) {
			document.querySelectorAll('tr[selectinserted]').forEach(function (r) {
				r.removeAttribute("selectinserted");
				r.style.backgroundColor = null;
			});
			tr.style.backgroundColor = "yellow";
			tr.setAttribute("selectinserted", "true");
		}
		else {
			tr.removeAttribute("selectinserted");
			tr.style.backgroundColor = null;
		}
	}

	setRowNum() {
		var i = 1;
		var table = document.querySelector("table[data-tformuladesc]");
		table.querySelectorAll('tr[data-rid]').forEach(function (tr) {
			tr.setAttribute("data-rid", i);
			tr.querySelector("span").innerHTML = i++;
		});
		i = 1;
		table.querySelectorAll('a[data-addrowup]').forEach(function (a) {
			a.setAttribute("data-addrowup", i++);
		});
		i = 1;
		table.querySelectorAll('a[data-addrowdown]').forEach(function (a) {
			a.setAttribute("data-addrowdown", i++);
		});
		i = 1;
		table.querySelectorAll('a[data-removerow]').forEach(function (a) {
			a.setAttribute("data-removerow", i++);
		});
		i = 1;
		table.querySelectorAll('a[data-editoperbefore]').forEach(function (a) {
			a.setAttribute("data-editoperbefore", i++);
		});
		i = 1;
		table.querySelectorAll('a[data-editoperafter]').forEach(function (a) {
			a.setAttribute("data-editoperafter", i++);
		});
		var _this = this;
		_this.setVisibleUpDownButton();
		_this.onChangeFormula();
	}

	setVisibleUpDownButton() {
		var table = document.querySelector("table[data-tformuladesc]");
		table.querySelectorAll("a[data-moverowup]").forEach(function (a) {
			a.style.visibility = "visible";
		});
		table.querySelectorAll("a[data-moverowdown]").forEach(function (a) {
			a.style.visibility = "visible";
		});

		table.querySelector("tr:first-child").nextSibling.querySelector("a[data-moverowup]").style.visibility = "hidden";
		table.querySelector("tr:last-child").querySelector("a[data-moverowdown]").style.visibility = "hidden";
	}

	onLostFocusTbEdit(prefix) {
		var parent = event.currentTarget.parentElement.parentElement;
		var span = parent.querySelector("span[data-spanOper" + prefix + "='']");
		var tb = parent.querySelector("input[data-tbOper" + prefix + "='']");
		span.style.visibility = "visible";
		span.innerHTML = tb.value;
		tb.style.display = "none";
		this.onChangeFormula();
	}

	editOperand(prefix) {
		var parent = event.currentTarget.parentElement.parentElement;
		parent.querySelector("span[data-spanOper" + prefix + "='']").style.visibility = "hidden";
		parent.querySelector("span[data-spanOper" + prefix + "='']").innerHTML = "";
		var tb = parent.querySelector("input[data-tbOper" + prefix + "='']");
		tb.style.display = "";
		tb.type = 'text';
		tb.focus();
		tb.setSelectionRange(tb.value.length, tb.value.length);
		this.onChangeFormula();
	}

	moverowup() {
		var parent = event.currentTarget.parentElement.parentElement;
		var currnum = parent.getAttribute('data-rid');
		var tbody = document.querySelector("table[data-tformuladesc='tformuladesc']").childNodes[0];
		var firstRow = tbody.rows[currnum - 1];
		var secondRow = tbody.rows[currnum];
		firstRow.parentNode.insertBefore(secondRow, firstRow);
		this.setRowNum();
	}

	moverowdown() {
		var parent = event.currentTarget.parentElement.parentElement;
		var currnum = parent.getAttribute('data-rid');
		var tbody = document.querySelector("table[data-tformuladesc='tformuladesc']").childNodes[0];
		var firstRow = tbody.rows[currnum];
		var secondRow = tbody.rows[Number(currnum) + 2];
		firstRow.parentNode.insertBefore(firstRow, secondRow);
		this.setRowNum();
	}

	removerow() {
		var parent = event.currentTarget.parentElement.parentElement;
		var tableDesc = document.querySelector("table[data-tformuladesc='tformuladesc']");

		var currnum = parent.getAttribute('data-rid');
		if (tableDesc.childNodes[0].childNodes.length > 2) {
			tableDesc.childNodes[0].removeChild(document.querySelector("tr[data-rid='" + currnum + "']"));
			this.setRowNum();
		}

		if (tableDesc.childNodes[0].childNodes.length > 3) {
			var aDelete = tableDesc.childNodes[0].childNodes[1].childNodes[5].querySelector("a[data-removerow]");
			aDelete.visibility = false;
			//alert("Формула должна содержать хотя бы одну строку для расчета");
		}
		//else {
		//	var row = tableDesc.childNodes[0].childNodes[1];
		//	row.querySelector("data[data-objectlabel]").innerHTML="";
		//	row.querySelector("data[data-spanoperbefore]").innerHTML = "";
		//	row.querySelector("data[data-spanoperafter]").innerHTML = "";
		//	row.querySelector("input[tboperbefore]").innerHTML = "";
		//	row.querySelector("input[tboperafter]").innerHTML = "";
		//	row.querySelector("data[data-tdnum]").innerHTML = "";
		//}
	}

	addrowup() {
		var parent = event.currentTarget.parentElement.parentElement;
		var currnum = parent.getAttribute('data-rid');

		var aDelete = parent.querySelector("a[data-removerow]");
		aDelete.style.visibility = "";

		var newEl = document.querySelector("tr[data-rid='" + currnum + "']").cloneNode(true);
		var table = document.querySelector("table[data-tformuladesc='tformuladesc']");
		var newRow = table.insertRow(currnum);
		newEl.setAttribute("data-newrow", true);
		parent.parentElement.insertBefore(newEl, newRow.nextSibling);
		this.setNewRowProps();
		this.setRowNum();
	}

	addrowdown() {
		var parent = event.currentTarget.parentElement.parentElement;
		var currnum = parent.getAttribute('data-rid');

		var aDelete = parent.querySelector("a[data-removerow]");
		aDelete.style.visibility = "";

		var oldel = document.querySelector("tr[data-rid='" + currnum + "']");
		var newel = document.querySelector("tr[data-rid='" + currnum + "']").cloneNode(true);
		newel.setAttribute("data-newrow", true);
		parent.parentElement.insertBefore(newel, oldel.nextSibling);
		this.setNewRowProps();
		this.setRowNum();
	}

	removeAttributesID(row) {
		var spanObject = row.querySelector("span[data-objectlabel]");
		if (spanObject != null) {
			spanObject.removeAttribute('attrdescr-iscontract');
			spanObject.removeAttribute('attrdescr-iscontractclause');
			spanObject.removeAttribute('attrdescr-sectionid');
			spanObject.removeAttribute('attrdescr-sectiondataid');
			spanObject.removeAttribute('attrdescr-channel');
		}
	}

	setAttributesID(code, id, tr) {
		var spanObject = tr.querySelector("span[data-objectlabel]");
		if (code == 0) {
			spanObject.setAttribute('attrdescr-iscontract', id);
		}
		else if (code == 1) {
			spanObject.setAttribute('attrdescr-iscontractclause', id);
		}
		else if (code == 2) {
			spanObject.setAttribute('attrdescr-sectionid', id);
		}
		else if (code == 3) {
			spanObject.setAttribute('attrdescr-sectiondataid', id);
		}
		else if (code == 4) {
			spanObject.setAttribute('attrdescr-sectiondataid', id);
		}
	}
}

export { baseformulaeditor };